import React, { useEffect, useState } from "react";
import siteLogo from "../../../assets/images/logo.png";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import useForm from "../../../hooks/useForm";
import { formValidate } from "../../../helpers/formValidate";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { sendOtp } from "../../../services/ProfileService";
import VerifyOtpForm from "./VerifyOtpForm";
import ChangePassword from "./ChangePassword";
import { useSelector } from "react-redux";
import adminbg from "../../../assets/images/adminbg.jpg";
import Image from "../../../components/elements/Image";

const validation = {
  email: { required: true, message: "Email is required" },
};

const ForgotPassword = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
  } = useForm({}, validation);
  const navigate = useNavigate();
  const location = useLocation();

  const [errorMessage, setErrorMessage] = useState({
    color: "red-600",
    message: null,
  });
  const [loaded, setLoaded] = useState(true);
  const [isOtp, setIsOtp] = useState(false);
  const [email, setEmail] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [verifiedOtpData, setVerifiedOtpData] = useState();
  const [showResendButton, setShowResendButton] = useState(false);
  const [timer, setTimer] = useState(60);

  const otpSubmit = async (values) => {
    setLoaded(false);
    try {
      await sendOtp({
        requestType: "RESETPASSWORD",
        email: email,
      }).then((res) => {
        if (res?.status === 201) {
          toast.success("OTP Code Sent To Your Email Id.");
          setIsOtp(true);
          setEmail(email);
          setTimer(60);
          setShowResendButton(true);
        } else {
          toast.error(res?.data?.message);
        }
      });
      setLoaded(true);
    } catch (error) {
      setLoaded(true);
      setIsOtp(false);
      toast.error(error);
    }
  };

  useEffect(() => {
    let interval;
    if (showResendButton && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 1) {
            clearInterval(interval);
            setShowResendButton(false);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showResendButton, timer]);

  useEffect(() => {
    if (isOtp) {
      setShowResendButton(true);
    }
  }, [isOtp, isVerified]);
  const settings = useSelector((state) => state?.settings?.data);

  // const cancelChange = () => {
  //   navigate(`/signin`);
  // };
  return (
    <div className="w-full min-h-screen flex items-center justify-center py-3 px-5 relative">
      <div className="absolute w-full h-full top-0">
        <Image src={adminbg} alt={""} className="w-full h-full object-cover" />
      </div>
      <div className="w-full max-w-md xl:max-w-[430px] bg-gradient-to-b from-slate-100 to-primary/20 pt-11 pb-2 shadow-md border-l-2 border-primary absolute z-10 rounded-r-xl">
        <div className="flex min-h-full flex-1 flex-col justify-center py-4 lg:px-2">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto h-16 w-auto "
              src={settings?.favicon?.url || siteLogo}
              alt="Your Company"
            />

            {isOtp && (
              <h3 className="mt-1 text-center text-xl font-bold leading-9 tracking-tight text-sky-600">
                Change Password
              </h3>
            )}
            {!isOtp && (
              <>
                {/* <h3 className="mt-1 text-center text-xl font-bold leading-9 tracking-tight text-sky-600">Send Code</h3> */}
                <h4 className="my-2 text-center text-md font-bold leading-9 tracking-tight text-slate-600">
                  Enter Your Email To Reset Password
                </h4>
              </>
            )}
          </div>

          <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
            {!isOtp && (
              <>
                <form onSubmit={(event) => handleSubmit(event, otpSubmit)}>
                  <div className="mt-2">
                    <Input
                      label={"Email"}
                      labelClasses={"!text-slate-600 !text-xs !mb-1 !ml-3"}
                      inputType={"text"}
                      inputPlaceholder={"Enter your email"}
                      inputClasses={
                        "!h-12 !rounded-3xl !border-text-secondary/50 !text-black placeholder:!text-slate-500 focus:!border-primary"
                      }
                      value={values.email}
                      inputName={"email"}
                      onChange={(e) => {
                        handleChange(e);
                        setEmail(e.target.value);
                      }}
                      {...formValidate(errors, "email")}
                    />
                  </div>
                  <div className="flex justify-center items-center my-2">
                    <Button
                      buttonClasses={
                        "!w-full text-white hover:!bg-black focus-visible:outline justify-center rounded-3xl"
                      }
                      buttonHasLink={false}
                      buttonType={"submit"}
                      buttonLabel={"Send Code"}
                    />
                  </div>
                  <div className="flex justify-end">
                    <Button
                      buttonClasses={
                        "bg-transparent !text-slate-500 border-none hover:!text-slate-100 !w-full hover:!bg-transparent hover:!text-black !flex !item-baseline !gap-0.5"
                      }
                      buttonHasLink={true}
                      buttonType={"button"}
                      buttonLabel={"Back to login"}
                      buttonIcon={"fa-regular fa-circle-arrow-left"}
                      buttonIconPosition={"left"}
                      buttonLink={
                        location?.state === "admin"
                          ? "/admin/signin"
                          : "/signin"
                      }
                    />
                  </div>
                </form>
              </>
            )}

            {/* {isOtp && !isVerified && (
              <>
                <VerifyOtpForm
                  email={email}
                  setEmail={setEmail}
                  isVerified={isVerified}
                  setIsVerified={setIsVerified}
                  isOtp={isOtp}
                  setIsOtp={setIsOtp}
                  verifiedOtpData={verifiedOtpData}
                  setVerifiedOtpData={setVerifiedOtpData}
                />
                <div className="mt-2">
                  <Button
                    buttonClasses={
                      "w-full text-white !bg-sky-700 focus-visible:outline  justify-center rounded-md"
                    }
                    buttonHasLink={false}
                    buttonType={"button"}
                    buttonLabel={"Resend Code"}
                    buttonFunction={onSubmit}
                    isDisable={showResendButton}
                  />
                </div>
                {showResendButton && (
                  <div className="text-center text-red-700 mt-2">
                    Resend Code in {timer} seconds
                  </div>
                )}
              </>
            )} */}

            {isOtp && (
              <>
                <ChangePassword
                  email={email}
                  setEmail={setEmail}
                  showResendButton={showResendButton}
                  timer={timer}
                  otpSubmit={otpSubmit}
                  location={location}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
